import { createSlice } from "@reduxjs/toolkit";
import { getNotification, readNotification } from "./notificationAction";

const initialState = {
    loading: false,
    notifications: [],
    error: null
}


const notificationSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        addNotification(state, action) {
            state.notifications.push(action.payload)
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getNotification.pending, (state) => {
                state.loading = true
            })
            .addCase(getNotification.fulfilled, (state, action) => {
                state.loading = false
                state.notifications = action.payload
            })
            .addCase(getNotification.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })

        builder
            .addCase(readNotification.fulfilled, (state, action) => {
                const notificationId = action.payload
                const index = state.notifications.findIndex(notification => notification.id === notificationId)
                if (index !== -1) {
                    state.notifications[index] = {
                        ...state.notifications[index],
                        read: true
                    }
                }
            })

    }
})


export const { addNotification } = notificationSlice.actions
export default notificationSlice.reducer